import React from 'react';
import styled from 'styled-components';
import get from 'lodash/get';

import Tooltip from 'modules/Prices/components/tooltip';
import BarGraph from 'components/Charts/BarGraph';
import { getLabels, roundDecimal, roundValue } from 'modules/Prices/helpers';

import { components } from 'apiTyped/types';

const CompareBarChartDiv = styled.div`
  .rhcTooltipContainer {
    min-width: 350px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    width: 100%;
    margin-bottom: 10px;

    > p {
      color: #abb5be;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-weight: 600;
    }
  }
  .rhcTooltipValues {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 75%;

    p {
      margin-left: 5px;
    }
  }
  .rhcTooltipValues > * {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 33%;
    text-align: center;
  }
  .rhcTooltipValues > div:not(:last-child) {
    margin-right: 15px;
  }

  .rhcTooltip {
    padding: 12px;
    min-width: 250px;
  }
  .rhcDate {
    color: #abb5be;
    text-transform: uppercase;
  }
  .rhcLabel {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }
`;

const CompareBarChart = ({
  data,
  activeRadioButton,
  currency
}: {
  data: components['schemas']['DataDetail'][];
  activeRadioButton: string;
  currency: string;
}) => {
  const labels = getLabels(data, activeRadioButton, false);

  return (
    <CompareBarChartDiv>
      <BarGraph
        angle={-60}
        offset={15}
        position="top"
        data={data}
        isAnimationActive={false}
        colors={['#e25d34', '#1f2b37', '#a5aaaf', '#525d69']}
        tooltipOffset={{
          x: -70,
          y:
            currency && currency !== get(data, '[0].displayed_currency', 'EUR')
              ? -40 * data.length
              : -20 * data.length
        }}
        labels={labels}
        showLabel
        renderTooltip={(props: any) => (
          <Tooltip data={props} labels={labels} currency={currency} />
        )}
        yAxisProps={{
          type: 'number',
          scale: 'linear',
          interval: 'preserveStartEnd',
          domain: [
            0,
            (dataMax: number) => roundDecimal(dataMax + dataMax / 10 + 5, -1)
          ],
          tickFormatter: (value: number) =>
            roundValue(value, 10).toLocaleString('fr-FR', {
              style: 'currency',
              currency: currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
        }}
      />
    </CompareBarChartDiv>
  );
};

export default CompareBarChart;
